var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11872 3.67641L6.73039 2.20304C7.94985 -0.734343 12.0502 -0.734343 13.2697 2.20302L13.8813 3.67635C14.1024 4.2088 14.5827 4.57414 15.1353 4.63677L16.8423 4.83021C19.8439 5.17036 21.0739 8.91073 18.8967 11.0174L17.4474 12.4199C17.0549 12.7996 16.8799 13.3639 16.988 13.9107L17.3379 15.682C17.9496 18.7791 14.6077 21.1345 11.9613 19.434L10.8165 18.6985C10.3164 18.3771 9.68368 18.3771 9.18348 18.6985L8.0388 19.434C5.39239 21.1345 2.05041 18.7791 2.66222 15.682L3.01213 13.9107C3.12015 13.3639 2.9452 12.7997 2.55261 12.4198L1.10337 11.0175C-1.07392 8.91074 0.156137 5.17036 3.15776 4.83021L4.86468 4.63677C5.41737 4.57414 5.89769 4.20882 6.11872 3.67641ZM12.0341 4.44321L11.4226 2.9699C10.8857 1.6767 9.1144 1.6767 8.57754 2.96988L7.96587 4.44326C7.46763 5.64338 6.36878 6.47912 5.08989 6.62405L3.38297 6.81749C2.07336 6.9659 1.52273 8.64026 2.49413 9.58017L3.94334 10.9825C4.82519 11.8357 5.21337 13.0877 4.97422 14.2983L4.62431 16.0696C4.35026 17.4569 5.81233 18.4873 6.95766 17.7514L8.10235 17.0159C9.26117 16.2713 10.7389 16.2713 11.8977 17.0159L13.0424 17.7514C14.1877 18.4873 15.6498 17.4569 15.3758 16.0696L15.0259 14.2983C14.7867 13.0877 15.1748 11.8357 16.0566 10.9826L17.506 9.58015C18.4773 8.64026 17.9267 6.9659 16.6171 6.81749L14.9101 6.62405C13.6313 6.47912 12.5325 5.64338 12.0341 4.44321Z",
    fill: "#091B3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollect);
export default __webpack_public_path__ + "static/media/collect.69bed30ab4a1de82b9a4965cd45b98ab.svg";
export { ForwardRef as ReactComponent };